import React from "react";

function PageTemplate({
  children,
  className = "",
  containerClassName = "mx-auto py-8 px-6",
  title,
  showTitle = true,
  headerActions = null,
}) {
  return (
    <div className={`min-h-screen bg-gray-50 pt-8 pb-8 ${className}`}>
      <div className="mx-auto">
        {showTitle && title && (
          <div className="flex items-center justify-between mb-6">
            <h1 className="text-4xl font-bold text-gray-900 leading-tight">
              {title}
            </h1>
            {headerActions}
          </div>
        )}
        <div className={containerClassName}>{children}</div>
      </div>
    </div>
  );
}

export default PageTemplate;
